import React from 'react'
import { SkeletonBar } from './DashboardSkeletonBar'
import { schoolSurface } from './schoolEquipmentChrome'

const HikvisionNvrDashboardSkeleton = () => (
  <div className="flex flex-col gap-6" aria-busy="true" aria-label="Загрузка видеорегистратора">
    <SkeletonBar className="h-3 w-28 rounded-full" />

    <header className="-mt-3 flex flex-col gap-4 md:flex-row md:items-start md:justify-between">
      <div className="min-w-0">
        <SkeletonBar className="mb-2 h-2.5 w-32" />
        <div className="flex flex-wrap items-center gap-3">
          <SkeletonBar className="h-9 w-56 max-w-full md:h-10 md:w-72" />
          <div className="flex items-center gap-1.5">
            <SkeletonBar className="h-2 w-2 rounded-full" />
            <SkeletonBar className="h-3.5 w-24" />
          </div>
        </div>
        <div className="mt-3 flex flex-wrap items-center gap-2">
          <SkeletonBar className="h-3.5 w-36" />
          <SkeletonBar className="h-3 w-2" />
          <SkeletonBar className="h-3.5 w-28" />
          <SkeletonBar className="h-3 w-2" />
          <SkeletonBar className="h-3.5 w-16" />
          <SkeletonBar className="ml-2 h-3.5 w-24" />
        </div>
      </div>
      <SkeletonBar className="h-10 w-28 rounded-xl" />
    </header>

    <section className="grid grid-cols-2 gap-2 sm:grid-cols-5">
      {Array.from({ length: 5 }).map((_, index) => (
        <div key={index} className={`rounded-2xl px-4 py-3 ${schoolSurface.tile}`}>
          <SkeletonBar delay={`${index * 70}ms`} className="h-2.5 w-14" />
          <SkeletonBar delay={`${index * 70}ms`} className="mt-2 h-7 w-12" />
        </div>
      ))}
    </section>

    <section className={`rounded-3xl p-6 ${schoolSurface.section}`}>
      <header className="mb-4 flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
        <div className="flex flex-wrap items-center gap-3">
          <SkeletonBar className="h-6 w-36" />
          <div className="inline-flex rounded-xl bg-surface-2 p-1">
            <SkeletonBar className="h-7 w-24 rounded-lg" />
            <SkeletonBar className="ml-1 h-7 w-20 rounded-lg" />
          </div>
        </div>
        <div className="inline-flex rounded-xl bg-surface-2 p-1">
          {['w-12', 'w-16', 'w-16', 'w-14', 'w-16'].map((width, index) => (
            <SkeletonBar key={index} delay={`${index * 50}ms`} className={`h-7 ${width} rounded-lg`} />
          ))}
        </div>
      </header>

      <div className={`rounded-3xl p-5 ${schoolSurface.card}`}>
        <div className="mb-3 flex items-baseline justify-between">
          <SkeletonBar className="h-3 w-40" />
        </div>
        <SkeletonBar className="mb-5 h-2.5 w-full rounded-full" />
        <SkeletonBar className="h-80 w-full rounded-2xl" />
      </div>
    </section>

    <section className={`overflow-hidden rounded-3xl ${schoolSurface.section}`}>
      <div className="flex items-center justify-between gap-4 px-6 py-5">
        <SkeletonBar className="h-6 w-24" />
        <div className="flex items-center gap-3">
          <SkeletonBar className="h-6 w-10" />
          <SkeletonBar className="h-5 w-5 rounded-full" />
        </div>
      </div>
    </section>

    <section className={`rounded-3xl p-6 ${schoolSurface.section}`}>
      <header className="mb-4 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <SkeletonBar className="h-6 w-40" />
        <div className="flex items-center gap-2">
          <div className={`inline-flex rounded-xl p-0.5 ${schoolSurface.tile}`}>
            <SkeletonBar className="h-8 w-20 rounded-lg" />
            <SkeletonBar className="ml-0.5 h-8 w-20 rounded-lg" />
          </div>
          <SkeletonBar className="h-8 w-24 rounded-xl" />
        </div>
      </header>
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4">
        {Array.from({ length: 8 }).map((_, index) => (
          <div key={index} className={`rounded-2xl p-3 ${schoolSurface.card}`}>
            <SkeletonBar delay={`${index * 40}ms`} className="aspect-video w-full rounded-xl" />
            <SkeletonBar delay={`${index * 40}ms`} className="mt-2 h-3 w-3/4" />
            <SkeletonBar delay={`${index * 40}ms`} className="mt-1.5 h-2.5 w-1/2" />
          </div>
        ))}
      </div>
    </section>
  </div>
)

export default HikvisionNvrDashboardSkeleton
